<form class="kt-form" [formGroup]="merchantForm" *ngIf="merchantForm" autocomplete="off">
  <div class="row">
    <div class="form-group col-lg-4">
      <label>Merchant Name</label>
      <div class="input-group" style="width: 100%;">
        <input
          type="text"
          formControlName="merchant_name"
          class="form-control"
          placeholder="Enter Merchant Name"
          style="width: 100%;"
        />
      </div>
      <mat-error  *ngIf="formValidator.formErrors.merchant_name">
       {{formValidator.formErrors.merchant_name}}
      </mat-error>
    </div>
    <div class="form-group col-lg-4">
      <label>First Name</label>
      <div class="input-group" style="width: 100%;">
        <input
          type="text"
          formControlName="fname"
          class="form-control"
          placeholder="Enter First Name"
          style="width: 100%;"
        />
      </div>
        <mat-error  *ngIf="formValidator.formErrors.fname">
         {{formValidator.formErrors.fname}}
        </mat-error>
    </div>
    <div class="form-group col-lg-4">
      <label>Last Name</label>
      <div class="input-group" style="width: 100%;">
        <input
          type="text"
          formControlName="lname"
          class="form-control"
          placeholder="Enter Last Name"
          style="width: 100%;"
        />
      </div>
        <mat-error  *ngIf="formValidator.formErrors.lname">
         {{formValidator.formErrors.lname}}
        </mat-error>
    </div>
    <div class="form-group col-lg-4">
      <label>Email</label>
      <div class="input-group" style="width: 100%;">
        <input
          type="email"
          formControlName="email"
          class="form-control"
          placeholder="Enter Email"
          style="width: 100%;"
        />
      </div>
        <mat-error  *ngIf="formValidator.formErrors.email">
         {{formValidator.formErrors.email}}
        </mat-error>
    </div>
    <div class="form-group col-lg-4">
      <label>Mobile</label>
      <div class="input-group" style="width: 100%;">
        <input
          type="text"
          formControlName="mobile"
          class="form-control"
          placeholder="Enter Mobile"
          style="width: 100%;"
        />
      </div>
        <mat-error  *ngIf="formValidator.formErrors.mobile">
         {{formValidator.formErrors.mobile}}
        </mat-error>
    </div>
    <div class="form-group col-lg-4">
      <label>CallBack Url</label>
      <div class="input-group" style="width: 100%;">
        <input
          type="text"
          formControlName="callBackUrl"
          class="form-control"
          placeholder="Enter Callback url"
          style="width: 100%;"
        />
      </div>
        <mat-error  *ngIf="formValidator.formErrors.callBackUrl">
         {{formValidator.formErrors.callBackUrl}}
        </mat-error>
    </div>
  </div>
</form>
<div class="form-group col-lg-4">
  <label>Allowed Domains</label>
  <form *ngFor="let domainForm of domainForms ; let i = index" [formGroup]="domainForm" autocomplete="off" class="domains">
    <input
      type="text"
      formControlName="domain"
      class="form-control"
      placeholder="Enter Domain"
      style="width: 100%;"
    />
    <button *ngIf="i == 0" class="btn btn-primary domain-button" (click)="addDomain()">
      <span class="domain-button-name">Add</span>
      <i class="fas fa-plus domains-plus"></i>
    </button>
    <button *ngIf="i != 0" class="btn btn-primary domain-button" (click)="removeDomain(i)">
      <span class="domain-button-name">Remove</span>
      <i class="fas fa-times domains-plus"></i>
    </button>
  </form>
</div>
<div class="form-group col-lg-4">
  <label>Payment Options </label>
  <div class="input-group" style="width: 100%;">
    <select
      (change)="paymentOptionChange({value:f.value})"
      class="form-control"
      #f
    >
    <option disabled value="null" selected>Choose Payment Option</option>

      <option

        *ngFor="let paymentMethod of paymentMethods"
        [value]="paymentMethod.display_name"
        >{{ paymentMethod.display_name }}
      </option>
    </select>
  </div>

</div>

<div *ngFor="let paymentOption of selectedPaymentOptions ; let i = index">
  <form class="kt-form" *ngIf="paymentOption === PaymentOptionsName.CASH" [formGroup]="cashForm" autocomplete="off">
    <div class="row groupInput">
      <div class="removeContaner">
        <span class="deletePayment" (click)="deletePaymentOption(i)">X</span>
      </div>
      <h4>Cash</h4>
      <div formArrayName="cashPrivders"  class="cashProv">
        <div class="cashProv" *ngFor="let cash of cashPrivders.controls; let i = index">
          <div *ngIf="i > 0" class="customDelete">
            <span class="" (click)="removeCash(i)">X</span>
          </div>
          <div class="cashProv" [formGroupName]="i">
            <div class="form-group col-lg-4">
              <label>Provider</label>
              <div class="input-group" style="width: 100%;">
                <select
                  style="border: 1px #cccccc solid; padding: 0.5rem"
                  formControlName="providerId"
                >
                  <option
                    *ngFor="let provider of cashProviders"
                    [value]="provider.id"
                    >{{ provider.name }}
                  </option>
                </select>
              </div>
              <mat-error *ngIf="cash.get('providerId').invalid">
                Provider is required
              </mat-error>
            </div>

            <div class="form-group col-lg-4">
              <label>Merchant Id</label>
              <div class="input-group" style="width: 100%;">
                <input
                  type="number"
                  formControlName="merchantId"
                  class="form-control"
                  placeholder="Enter Merchant Id"
                  style="width: 100%;"
                />
              </div>
            </div>

            <div class="row groupInput">
              <h4>Fee</h4>

              <div class="form-group col-lg-4">
                <label>Merchant fees Rate (%)</label>
                <div class="input-group" style="width: 100%;">
                  <input
                    type="number"
                    formControlName="OnUSRate"
                    class="form-control"
                    placeholder="Enter Merchant fees Rate (%)"
                    style="width: 100%;"
                  />
                </div>

                <mat-error *ngIf="cash.get('OnUSRate').invalid">
                  Merchant fees Rate (%) is required
                </mat-error>
              </div>

              <div class="form-group col-lg-4">
                <label>Merchant Flat Rate</label>
                <div class="input-group" style="width: 100%;">
                  <input
                    type="number"
                    formControlName="flatRate"
                    class="form-control"
                    placeholder="Enter Merchant Flat Rate"
                    style="width: 100%;"
                  />
                </div>

                <mat-error *ngIf="cash.get('flatRate').invalid">
                  Merchant Flat Rate is required
                </mat-error>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="btn btn-primary pull-right" (click)="addCashProvider({})">Add Provide</button>

    </div>
  </form>
  <form class="kt-form" *ngIf="paymentOption === PaymentOptionsName.MIGS_CREEDIT_CARD || paymentOption === PaymentOptionsName.MPGS_CREEDIT_CARD"   [formGroup]="creditForm" autocomplete="off">
    <div class="row groupInput mb-3">
      <div class="removeContaner">
        <span class="deletePayment" (click)="deletePaymentOption(i)">X</span>
      </div>
      <h4>Credit Card</h4>
        <div class="form-group col-lg-4">
          <label>Provider</label>
          <div class="input-group" style="width: 100%;">
            <select
              formControlName="providerId"
              (change)="providerChange($event)"
              class="form-control"
            >
          <option disabled value="null" selected>Choose Provider</option>
              <option
                *ngFor="let provider of creditCardProviders"
                [value]="provider.id"
                >{{ provider.name }}
              </option>
            </select>
          </div>
          <mat-error *ngIf="creditForm.get('providerId').invalid">
            Provider is required
          </mat-error>
        </div>

        <div class="form-group col-lg-4">
          <label>Merchant Id</label>
          <div class="input-group" style="width: 100%;">
            <input
              type="text"
              formControlName="merchantId"
              class="form-control"
              placeholder="Enter Merchant Id"
              style="width: 100%;"
            />
          </div>
          <mat-error *ngIf="creditForm.get('merchantId').invalid">
            Merchant Id is required
          </mat-error>
        </div>

        <div class="form-group col-lg-4">
          <label>Access Code</label>
          <div class="input-group" style="width: 100%;">
            <input
              type="text"
              formControlName="accessCode"
              class="form-control"
              placeholder="Enter Access Code"
              style="width: 100%;"
            />
          </div>
          <mat-error *ngIf="creditForm.get('accessCode').invalid">
            Access Code is required
          </mat-error>
        </div>

        <div class="form-group col-lg-4" *ngIf="creditForm.get('secureHashSecret')">
          <label>Secure Hash Secret</label>
          <div class="input-group" style="width: 100%;">
            <input
              type="text"
              formControlName="secureHashSecret"
              class="form-control"
              placeholder="Enter Secure Hash Secret"
              style="width: 100%;"
            />
          </div>
          <mat-error *ngIf="creditForm.get('secureHashSecret').invalid">
            Secure Hash Secret is required
          </mat-error>
        </div>

        <div class="row groupInput">
          <h4>Fee</h4>
          <div class="form-group col-lg-4">
            <label>Merchant Off us Rate (%)</label>
            <div class="input-group" style="width: 100%;">
              <input
                type="number"
                formControlName="OffUsRate"
                class="form-control"
                placeholder="Enter Merchant Off us Rate (%)"
                style="width: 100%;"
              />
            </div>

            <mat-error *ngIf="creditForm.get('OffUsRate').invalid">
              Merchant Off us Rate (%) is required
            </mat-error>
          </div>

          <div class="form-group col-lg-4">
            <label>Merchant On us Rate (%)</label>
            <div class="input-group" style="width: 100%;">
              <input
                type="number"
                formControlName="OnUSRate"
                class="form-control"
                placeholder="Enter Merchant On us Rate (%)"
                style="width: 100%;"
              />
            </div>

            <mat-error *ngIf="creditForm.get('OnUSRate').invalid">
              Merchant On us Rate (%) is required
            </mat-error>
          </div>

          <div class="form-group col-lg-4">
            <label>Merchant Flat Rate</label>
            <div class="input-group" style="width: 100%;">
              <input
                type="number"
                formControlName="flatRate"
                class="form-control"
                placeholder="Enter Merchant Flat Rate"
                style="width: 100%;"
              />
            </div>

            <mat-error *ngIf="creditForm.get('flatRate').invalid">
              Merchant Flat Rate is required
            </mat-error>
          </div>
        </div>

    </div>
  </form>
</div>
<button [disabled]="formsValidation" class="btn btn-primary" (click)="sendFormData()">{{title}} Merchant</button>
